import { FC, useEffect, useState } from 'react'
import { Table } from 'reactstrap'
import classnames from 'classnames'

import { ConnectedHelpTooltip } from '../../../../@paco/connectors'
import trans from '../../../../@paco/helpers/trans'

import { SpecialDayViewModel, UserWithAvailability } from '../../../../models'
import { AvailabilityResourceTypes } from '../AvailabilityDays/subcomponents/Availability/Availability'
import ListViewTableHead from './subcomponents/ListViewTableHead/ListViewTableHead'
import ListViewUser from './subcomponents/ListViewUser/ListViewUser'

import './ListViewTable.scss'

interface ListViewTableProps {
    isLoading: boolean;
    isFilterEmploymentTypeBadgeActive: boolean;
    canAddPlannings: boolean;
    isFirstRowSticky: boolean;
    isFirstColumnSticky: boolean;
    days: Date[];
    specialDays?: SpecialDayViewModel[];
    startDate: Date; // @TODO: Must this be removed because it is not used?
    endDate: Date; // @TODO: Must this be removed because it is not used?
    users: UserWithAvailability[];
    onAvailabilityClick: (resource: AvailabilityResourceTypes) => void;
    onAddButtonClick: (date: Date, user: UserWithAvailability) => void;
}

const ListViewTable: FC<ListViewTableProps> = ({
    isLoading,
    isFilterEmploymentTypeBadgeActive,
    canAddPlannings,
    isFirstRowSticky,
    isFirstColumnSticky,
    days,
    specialDays,
    onAvailabilityClick,
    onAddButtonClick,
    ...props
}) => {
    const classNames = classnames('list-view-table table-container-responsive', {
        'list-view-table--first-row-sticky': isFirstRowSticky,
        'list-view-table--first-column-sticky': isFirstColumnSticky,
    })

    const [users, setUsers] = useState<UserWithAvailability[]>(props.users || [])

    useEffect((): void => {
        if (! isLoading && props.users.length) {
            setUsers(props.users)
        }
    }, [props.users, isLoading])

    return (
        <div className={classNames}>
            <ConnectedHelpTooltip
                index={2}
                videoSrc="/help/assign-shift.webm"
                route="list-view"
                subTitle={trans('help.listView.assignShift.title')}
                text={trans('help.listView.assignShift.text')}
                title={trans('help.listView.title')}
                showMobileInfoWarning
                className="list-view-table__assign-shift-help-tooltip"
            />

            <ConnectedHelpTooltip
                index={3}
                route="list-view"
                subTitle={trans('help.listView.assignConceptShifts.title')}
                text={trans('help.listView.assignConceptShifts.text')}
                title={trans('help.listView.title')}
                className="list-view-table__assign-concept-shifts-help-tooltip"
            />

            <div className="table-container list-view-table__table-container">
                <Table className="list-view-table__table">
                    <ListViewTableHead
                        dates={days}
                        specialDays={specialDays}
                    />

                    <tbody>
                        {users.map(user => (
                            <ListViewUser
                                key={user.id}
                                isLoading={isLoading}
                                isFilterEmploymentTypeBadgeActive={isFilterEmploymentTypeBadgeActive}
                                canAddPlannings={canAddPlannings}
                                user={user}
                                range={days}
                                onAvailabilityClick={onAvailabilityClick}
                                onAddButtonClick={onAddButtonClick}
                            />
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export default ListViewTable
